import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { LogoCard } from "@/components/brand/BrandLogo";
import { AUDIENCES, NAV, SITE, waLink } from "@/lib/content";

export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="grain relative overflow-hidden border-t border-cream/10 bg-forest-night pb-32 pt-20 text-cream lg:pb-14">
      <div className="wrap relative grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <LogoCard />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/80">
            {SITE.founder} is a wellness coach, not a dietitian. For medical conditions we provide nutrition support alongside your doctor's treatment.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-10 lg:col-span-5">
          <div>
            <p className="eyebrow-dark">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV.map((n) => <li key={n.to}><Link to={n.to} className="link-line text-cream/85 hover:text-cream" data-testid={`footer-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</Link></li>)}
            </ul>
          </div>
          <div>
            <p className="eyebrow-dark">Support for</p>
            <ul className="mt-5 space-y-3 text-sm">
              {AUDIENCES.map((a) => <li key={a.slug}><Link to={`/${a.slug}`} className="link-line text-cream/85 hover:text-cream" data-testid={`footer-audience-${a.slug}`}>{a.title}</Link></li>)}
            </ul>
          </div>
        </div>
        <address className="not-italic lg:col-span-3" data-testid="footer-nap">
          <p className="eyebrow-dark">Talk to Sony</p>
          <p className="mt-5 font-display text-2xl">{SITE.name}</p>
          <ul className="mt-4 space-y-3 text-sm text-cream/85">
            <li><a href={`tel:${SITE.phoneTel}`} className="flex items-center gap-3 hover:text-cream" data-testid="footer-phone"><Phone className="h-4 w-4 text-gold-soft" /> {SITE.phoneDisplay}</a></li>
            <li><a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-cream" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-gold-soft" /> WhatsApp {SITE.phoneDisplay}</a></li>
            <li><a href={`mailto:${SITE.email}`} className="flex items-center gap-3 break-all hover:text-cream" data-testid="footer-email"><Mail className="h-4 w-4 shrink-0 text-gold-soft" /> {SITE.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="mt-1 h-4 w-4 shrink-0 text-gold-soft" /><span>{SITE.street}, {SITE.locality}<br />{SITE.cityName}, {SITE.region} {SITE.postalCode}<br /><span className="text-cream/70">{SITE.online}</span></span></li>
            <li className="flex items-start gap-3"><Clock className="mt-1 h-4 w-4 shrink-0 text-gold-soft" /><span>{SITE.hours}</span></li>
          </ul>
        </address>
      </div>
      <div className="wrap relative mt-16 flex flex-col gap-3 border-t border-cream/10 pt-6 text-xs text-cream/70 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} {SITE.name}. {SITE.disclaimer}</p>
        <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link to="/privacy" className="link-line hover:text-cream" data-testid="footer-privacy">Privacy Policy</Link>
          <span>Coaching information only. Not medical advice.</span>
        </p>
      </div>
    </footer>
  );
}
